export const categories = [
  {
    name: 'Freshmen',
    image: 'https://th.bing.com/th/id/OIP.nThE4IGU902Btt-qqjNdMQHaEK?pid=ImgDet&rs=1',
  },
  {
    name: 'Sophmores',
    image: 'https://www.100hdwallpapers.com/wallpapers/1920x1080/yellow_abstract-hd_wallpapers.jpg',
  },
  {
    name: 'Juniors',
    image: 'https://th.bing.com/th/id/OIP.5MGrR6sCzxmRRb1Gdk7eVwHaEK?pid=ImgDet&rs=1',
  },
  {
    name: 'Seniors',
    image: 'https://lh3.googleusercontent.com/UYYeZxlREzIeCQr7oWINr6r0KAz7cAmPJBu3fGlerKifA0SwXhni-3fHA-Xa9BS3B0w=h900',
  },
  {
    name: 'Sports',
    image: 'https://th.bing.com/th/id/R.3a192bb272c74942090c811583910574?rik=pfVDLKQPZIYt7w&riu=http%3a%2f%2fwww.signupgenius.com%2fimages%2fvertical%2fsports-baseball-football-basketball-soccer-ball.jpg&ehk=WqcfXot7vibUKc8liHh3n2gRYDEH5mzyMDysKyqYayg%3d&risl=&pid=ImgRaw&r=0',
  },
  {
    name: 'Events',
    image: 'https://th.bing.com/th/id/OIP.7TBdUTnE7GjqZBNwCWHbxQHaHa?pid=ImgDet&rs=1',
  },
  {
    name: 'Funny',
    image: 'https://www.clipartkey.com/mpngs/m/10-102910_laugh-vector-laughing-emoji-iphone-png.png',
  },
  {
    name: 'Other',
    image: '',
  },
];



export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
  image{
    asset->{
      url
    }
  },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;

export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title, 
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const pinDetailMorePinQuery = (pin) => {
  const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const searchQuery = (searchTerm) => {
  const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
        image{
          asset->{
            url
          }
        },
            _id,
            destination,
            postedBy->{
              _id,
              userName,
              image
            },
            save[]{
              _key,
              postedBy->{
                _id,
                userName,
                image
              },
            },
          }`;
  return query;
};

export const userQuery = (userId) => {
  const query = `*[_type == "user" && _id == '${userId}']`;
  return query;
};

export const userCreatedPinsQuery = (userId) => {
  const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const userSavedPinsQuery = (userId) => {
  const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};
